import { Fragment, memo, useReducer } from 'react';

import { DiscoveryWalletDrawer } from './discovery-wallet-drawer/DiscoveryWalletDrawer';
import { DiscoveryWelcomeDrawer } from './discovery-welcome-drawer/DiscoveryWelcomeDrawer';

type DiscoveryDrawersProps = {
  discoveryDuration: number;
  initialFillAmount: number;
  onRequestClose: () => void;
};

const stepReducer = (state, action) => {
  if (action.type === 'INCREMENT') {
    return state + 1;
  }

  if (action.type === 'DECREMENT') {
    return state - 1;
  }

  return state;
};

const DiscoveryDrawersBase = ({
  onRequestClose,
  discoveryDuration,
  initialFillAmount,
}: DiscoveryDrawersProps) => {
  const [currentStep, dispatch] = useReducer(stepReducer, 0);

  return (
    <Fragment>
      <DiscoveryWelcomeDrawer
        isOpen={currentStep === 0}
        onClickContinue={() => dispatch({ type: 'INCREMENT' })}
        discoveryDuration={discoveryDuration}
      />

      <DiscoveryWalletDrawer
        onRequestClose={onRequestClose}
        onClickContinue={onRequestClose}
        initialFillAmount={initialFillAmount}
        isOpen={currentStep === 1}
        onClickPrevious={() => dispatch({ type: 'DECREMENT' })}
      />
    </Fragment>
  );
};

DiscoveryDrawersBase.displayName = 'DiscoveryDrawers';

export const DiscoveryDrawers = memo(DiscoveryDrawersBase);
